import { handleActions } from 'redux-actions';
import { listReducer } from '@nextiva/engagement-ui';
import { createSelector } from 'reselect';

import TemplateListHandleActionsObj from 'config/templateList/TemplateListHandleActionsObj';
import SurveyListHandleActionsObj from 'config/surveyList/SurveyListHandleActionsObj';
import { DEFAULT_TEMPLATE_TYPE } from 'constants/templateList/TemplateListApiNames';
import * as SurveyTabs from 'constants/surveyList/SurveyTabKeys';

const {
  generateDefaultListParams,
  getItemListHandleActionsObj,
  getItemList,
  getItemListTabName,
  getItemListState,
  getItemListSelectedItems,
} = listReducer;

const generateParams = (listId, uniqueParams = {}) => ({
  ...generateDefaultListParams(listId),
  ...uniqueParams,
});

const initialState = {};

export default handleActions(
  {
    ...getItemListHandleActionsObj(generateParams),
    ...TemplateListHandleActionsObj,
    ...SurveyListHandleActionsObj,
  },
  initialState,
);

export const getListItemById = (state, listId, itemId) =>
  getItemList(state, listId).find(({ id }) => id === itemId);

export const getSurveyStatus = (state, listId, surveyId) =>
  getListItemById(state, listId, surveyId).status;

export const getSurveyResponseCount = (state, listId, surveyId) =>
  getListItemById(state, listId, surveyId).responseCount;

export const isCurrentSurveyTabFavorite = (state, listId) =>
  getItemListTabName(state, listId) === SurveyTabs.FAVORITE;

export const isCurrentSurveyTabArchive = (state, listId) =>
  getItemListTabName(state, listId) === SurveyTabs.ARCHIVE;

export const getSearchPreviewSurveyCount = (state, listId) =>
  getItemListState(state, listId).searchPreviewSurveyCount;

export const isListMounted = (state, listId) =>
  !!getItemListState(state, listId);

export const isTemplateDefault = (state, listId, itemId) =>
  getListItemById(state, listId, itemId).type === DEFAULT_TEMPLATE_TYPE;

export const isSelectedSurveyStatusArchived = createSelector(
  getItemListSelectedItems,
  selectedItems => Object.values(selectedItems).some(
    item => item.status === "archived",
  )
)

export const isAnyPlatformItemChecked = createSelector(
  getItemListSelectedItems,
  selectedItems =>
    Object.values(selectedItems).some(
      item => item.type === DEFAULT_TEMPLATE_TYPE,
    ),
);

export const isConnectSurveySelected = createSelector(
  getItemListSelectedItems,
  selectedItems => Object.values(selectedItems).some(
    item => item.type_ !== "common",
  )
);

export const isCommonSurveySelected = createSelector(
  getItemListSelectedItems,
  selectedItems => Object.values(selectedItems).some(
    item => item.type_ === "common",
  )
);

export const getOptimizedTemplatesIds = createSelector(
  getItemListSelectedItems, 
  selectedItems => Object.values(selectedItems).filter(
    item => item.type_ === "connect_template"
  ).map(item => item.id)
)